import urlBuilder from "@sanity/image-url";

const { VITE_SANITY_PROJECT_ID, VITE_SANITY_DATASET } = import.meta.env;

export const sanityImageUrlBuilder = urlBuilder({
  projectId: VITE_SANITY_PROJECT_ID,
  dataset: VITE_SANITY_DATASET,
});
